import { render } from "./SortBy.vue?vue&type=template&id=b69b3b76&ts=true"
import script from "./SortBy.vue?vue&type=script&lang=ts"
export * from "./SortBy.vue?vue&type=script&lang=ts"

import "./SortBy.vue?vue&type=style&index=0&id=b69b3b76&lang=scss"

import exportComponent from "/Users/matustrebaticky/projects/symbiosy/insights/insights-fe/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/SortBy.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b69b3b76"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b69b3b76', __exports__)) {
    api.reload('b69b3b76', __exports__)
  }
  
  module.hot.accept("./SortBy.vue?vue&type=template&id=b69b3b76&ts=true", () => {
    api.rerender('b69b3b76', render)
  })

}


export default __exports__